import { Skeleton } from "@/components/ui/skeleton"
import { useSearchParams } from "react-router"
import { useArticleSuppliers } from "../../../api/articlesApi"
import { SupplierActiveWorkSection } from "../../shared/SupplierActiveWorkSection"

/**
 * Every article carries its own supplier(s) — reuse the same active-work
 * section from the Supplier panel, scoped to this article's (primary)
 * supplier, so an article with multiple suppliers still shows one clear set
 * of inquiries/declarations rather than mixing several suppliers together.
 */
export function ArticleActiveWorkSection() {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")
  const { data: links = [], isLoading } = useArticleSuppliers(id)

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2 px-4 pb-4 pt-3">
        <Skeleton className="h-[76px] w-full rounded-lg" />
      </div>
    )
  }

  const primary = links.find((l) => l.active) ?? links[0]

  return <SupplierActiveWorkSection supplierId={primary?.supplierId ?? null} />
}
